import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "../views/admin/Login";
import Home from "../views/admin/Home";
import UserInfo from "../views/admin/UserInfo";


Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        component: Login,
        //hidden: true
    },
    {
        path: '/home',
        name: 'Home',
        component: Home,
        children: [
            {
                path: '/userInfo',
                name: '个人中心',
                component: UserInfo
            }
        ]
    }

]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

export default router
